<template>
  <div class="order-edit-record">
    <vx-list class="list-wrap" enable :api="api" :params="params" @load="onLoad">
      <div class="cwlist">
        <div class="cw" v-for="item in list" :key="item.id">
          <div class="ln ln1 van-hairline--bottom">
            <div class="l">{{ item.editTypeDesc }}</div>
            <div class="r">{{ item.createTime | formatDatetime('yyyy-MM-dd hh:mm') }}</div>
          </div>
          <div class="ln" v-if="item.productName">
            <div class="l">项目</div>
            <div class="r">{{ item.productName }}</div>
          </div>
          <div class="ln">
            <div class="l">修改前</div>
            <div class="r" v-if="item.type == 2">{{ item.beforeContent ? app.tool.date.formatDatetime(item.beforeContent, 'yyyy-MM-dd') : '-' }}</div>
            <vx-mult-input-show
              v-else-if="item.type == 6 && item.beforeContent"
              :list="JSON.parse(item.beforeContent).list"
              ></vx-mult-input-show>
            <div class="r" v-else>{{ item.beforeContent || '-' }}</div>
          </div>
          <div class="ln">
            <div class="l">修改后</div>
            <div class="r" v-if="item.type == 2">{{ item.afterContent ? app.tool.date.formatDatetime(item.afterContent, 'yyyy-MM-dd') : '-' }}</div>
            <vx-mult-input-show
              v-else-if="item.type == 6 && item.afterContent"
              :list="JSON.parse(item.afterContent).list"
              ></vx-mult-input-show>
            <div class="r" v-else>{{ item.afterContent || '-' }}</div>
          </div>
          <div class="ln">
            <div class="l">操作人</div>
            <div class="r">{{ item.operatorName }}</div>
          </div>
        </div>
      </div>
      <van-empty
        v-if="!loading && !list.length"
        image="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/tips/empty.png"
        description="没有找到编辑记录～"
        image-size="128"
        style="padding-top: 50px"
      ></van-empty>
    </vx-list>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pageTitle: '编辑记录',
      api: this.$api.findOrderEditPage,
      params: { orderId: this.$vxRoute.params.id },
      list: [],
      loading: true,
    };
  },
  filters: {},
  methods: {
    onLoad(list, res) {
      this.list = list;
      this.loading = false;
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped>
.order-edit-record {
  .list-wrap {
    height: 100%;
    .cwlist {
      padding: calc(var(--gap) * 4) calc(var(--gap) * 16);
      .cw {
        margin-top: calc(var(--gap) * 12);
        margin-bottom: calc(var(--gap) * 12);
        padding-left: calc(var(--gap) * 16);
        padding-right: calc(var(--gap) * 16);
        padding-bottom: calc(var(--gap) * 8);
        border-radius: var(--radius-sm);
        background: var(--white);
        overflow: hidden;
        .ln {
          display: flex;
          justify-content: space-between;
          padding-top: calc(var(--gap) * 6);
          padding-bottom: calc(var(--gap) * 6);
          .l {
            color: var(--g6);
          }
          .r {
            flex: 1;
            padding-left: calc(var(--gap) * 16);
            color: var(--g7);
            text-align: right;
          }
          &.ln1 {
            padding-top: calc(var(--gap) * 16);
            padding-bottom: calc(var(--gap) * 12);
            .l {
              color: var(--g8);
              font-weight: var(--bold);
            }
            .r {
              color: var(--g6);
            }
          }
        }
      }
    }
  }
}
</style>